import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=3500b2a2&scoped=true"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=3500b2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3500b2a2",
  null
  
)

export default component.exports